import React from "react";
import '../footer/footer.css';
import Footerlogo from '../../images/new_sitelogo.svg';
import Telegram from '../footer/telegram.svg';
import Twitter from '../footer/twitter.svg';
import Instagram from '../../images/instagram.svg';
import { ReactComponent as NCXGoogle } from '../../images/ncxgoogleplay.svg';
import { ReactComponent as NCXApple } from '../../images/ncxappstore.svg';
import MBLNCXGoogle from '../../images/ncxgoogleplay.svg';
import MBLNCXAppStore from '../../images/ncxappstore.svg';
import NCXBarcode from '../../images/ncx-barcode.png';
import { ReactComponent as NCXNewsletterarrow } from '../../images/ncx-newsletterarrow.svg';
import NCXNewsletter from '../newsletter/subscribe';
import { useTranslation } from "react-i18next";


function MyFooter() 
{
    const { t } = useTranslation();

    return(
        <div id="footerdiv">
            <div className="container footer">
                <div class="footer-row">
                    <div class="first-column ftr-col">
                        <h1>{t("products")}</h1>
                        <ul className="ul-one">
                            <li><a href="https://ncx.cx/buy-crypto">{t("buy_crypto")}</a></li>
                            <li><a href="https://exchange.ncx.cx/trade">{t("spot_trading")}</a></li>
                            <li><a href="https://ncx.cx/derivatives">{t("crypto_derivatives")}</a></li>
                            <li><a href="https://exchange.ncx.cx/markets">{t("markets")}</a></li>
                            <li><a href="https://bsc.ncx.cx/swap" target="_blank" rel="noreferrer">{t("cross_chain_dex")}</a></li>
                            <li><a href="https://ncx.cx/ncx-card">{t("ncx_card")}</a></li>
                            <li><a href="https://ncx.cx/wallet">{t("ncx_defi_wallet")}</a></li>
                            <li><a href="https://ncx.cx/ncx-token">{t("ncx_token")}</a></li>
                            <li><a href="https://ncx.cx/derivatives">{t("stocks_trading")}</a></li>
                            <li><a href="https://ncx.cx/derivatives">{t("forex_trading")}</a></li>
                            <li><a href="https://ncx.cx/derivatives">{t("commodities_trading")}</a></li>
                        </ul>
                        {/* <h1>Derivatives Trading</h1>
                        <ul className="ul-two">
                            <li><a href="#">Crypto Derivatives</a></li>
                            <li><a href="#">Equities Trading</a></li>
                            <li><a href="#">EFTs Trading</a></li>
                            <li><a href="#">Forex Trading</a></li>
                            <li><a href="#">Metals Trading</a></li>
                            <li><a href="#">Indices Trading</a></li>
                            <li><a href="#">Oil & Gas Trading</a></li>
                        </ul> */}
                    </div>
                    <div class="second-column ftr-col">
                        <h1>{t("services")}</h1>
                        <ul className="ul-one">
                            {/* <li><a href="https://ncx.cx/market-insights">{t("ncx_insights")}</a></li> */}
                            <li><a href="https://ncx.cx/rewards">{t("rewards_program")}</a></li>
                            <li><a href="https://ncx.cx/market-makers">{t("market_makers")}</a></li>
                            <li><a href="https://ncx.cx/institutional">{t("institutional_services")}</a></li>
                            <li><a href="https://ncx.cx/ncx-otc">{t("otc")}</a></li>
                            <li><a href="https://ncx.cx/ncx-ambassador">{t("ncx_ambassador")}</a></li>
                            <li><a href="https://ncx.cx/faq">{t("faq")}</a></li>
                            <li><a href="https://exchange.ncx.cx/support" target="_blank" rel="noreferrer">{t("support")}</a></li>
                            <li><a href="https://ncx.cx/about-us">{t("about_us")}</a></li>
                            {/* <li><a href="https://ncx.cx/market-insights">{t("media_press")}</a></li> */}
                        </ul>
                        {/* <h1>Company</h1>
                        <ul className="ul-two">
                            <li><a href="https://ncx.cx/insights">Media & Press</a></li>
                            <li><a href="https://ncx.cx/faq">FAQ</a></li>
                            <li><a href="#">Support</a></li>
                        </ul> */}
                    </div>
                    <div class="third-column ftr-col">
                        <h1>{t("legal")}</h1>
                        <ul className="ul-one">
                        <li><a href="https://ncx.cx/user-agreement">{t("user_agreement")}</a></li>
                            <li><a href="https://ncx.cx/kyc-aml-policy">{t("aml_kyc_policy")}</a></li>
                            <li><a href="https://ncx.cx/privacy-policy">{t("privacy_policy")}</a></li>
                            <li><a href="https://ncx.cx/api-agreement">{t("api_documentation")}</a></li>
                            <li><a href="https://ncx.cx/cookie-policy">{t("cookie_policy")}</a></li>
                            {/* <li className="hiddendss"><a>Red</a></li> */}
                        </ul>
                        <h1>{t("apps")}</h1>
                        <ul className="ul-two">
                            <li><a href="#" target="_blank" rel="noreferrer">{t("ncx_app_on_app_store")}</a></li>
                            <li><a href="https://play.google.com/store/apps/details?id=com.application.ncx" target="_blank" rel="noreferrer">{t("ncx_app_on_google_play_store")}</a></li>
                            <li><a href="#">{t("ncx_ctrader_on_app_store")}</a></li>
                            <li><a href="#">{t("ncx_ctrader_on_google_play_store")}</a></li>
                        </ul>
                    </div>
                    <div class="fourth-column ftr-col">
                        <div>
                            <div class="footer-logo"><a title="NCX" href="https://ncx.cx/"><img src={Footerlogo} alt="NCX" title="NCX" /></a></div>
                            <div className="app-barcode-row">
                                <div className="appsttore">
                                    <p>{t("mobile_app")}</p>
                                    <a href="https://play.google.com/store/apps/details?id=com.application.ncx" target="_blank" rel="noreferrer"><NCXGoogle /></a>
                                    <NCXApple />
                                </div>
                                <div className="bardcodd">
                                    < img src="https://res.cloudinary.com/dqbcnwbvy/image/upload/v1693062241/qr-cdeo-_yvvhfn.svg" alt="NCX Barcode to Download App" />
                                    <p>{t("scan_to_download_ncx_app")}</p>
                                </div>
                            </div>
                            <div class="social-media">
                                <p>{t("follow_us")}</p>
                                <div className="social-icons">
                                    <div class="icons"><a href="https://t.me/NCX_Official" target="_blank" rel="noreferrer"><img src={Telegram} alt="NCX" title="Telegram"/></a></div>
                                    <div class="icons"><a href="https://www.instagram.com/ncx.cx/" target="_blank" rel="noreferrer"><img src={Instagram} alt="NCX" title="Instagram" /></a></div>
                                    <div class="icons"><a href="https://twitter.com/NCX_CX" target="_blank" rel="noreferrer"><img src={Twitter} alt="NCX" title="Twitter" /></a></div>
                                </div>
                            </div>
                            <div className="fot-newsleter">
                                <p>{t("sign_up_for_updates")}</p>
                                <NCXNewsletter />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="copyright">
                    <p>{t("footer_copyright_1")} <a href="https://ncx.cx/user-agreement">{t("user_agreement")}</a>, <a href="https://ncx.cx/kyc-aml-policy">{t("aml_kyc_policy")}</a> {t("and")} <a href="https://ncx.cx/privacy-policy">{t("privacy_policy")}</a></p>
                    {/* <p>{t("footer_copyright_2")}</p> */}
                    <p>{t("footer_copyright_3")}</p>
                </div>
            </div>
            <div className="mobile-footer">
                <div className="mob-foot-head">
                    <div class="footer-logo"><a title="NCX" href="https://ncx.cx/"><img src={Footerlogo} alt="NCX" title="NCX" /></a></div>
                </div>
                <div className="mbl--menu foot--menu">
                    <details>
                        <summary>{t("trade")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://exchange.ncx.cx/trade" rel="noreferrer" target="_blank">{t("spot")}</a>
                            <a href="https://exchange.ncx.cx/markets" rel="noreferrer" target="_blank">{t("markets")}</a>
                            <a href="https://bsc.ncx.cx/swap" rel="noreferrer" target="_blank">{t("dex")}</a>
                        </div>
                    </details>
                    <details>
                        <summary>{t("products")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/buy-crypto">{t("buy_crypto")}</a>
                            <a href="https://ncx.cx/derivatives">{t("derivatives_trading")}</a>
                            <a href="https://ncx.cx/ncx-card">{t("ncx_card")}</a>
                            <a href="https://ncx.cx/wallet">{t("ncx_wallet")}</a>
                            <a href="https://ncx.cx/ncx-token">{t("ncx_token")}</a>
                            {/* <a href="https://ncx.cx/market-insights">{t("news_insights")}</a> */}
                        </div>
                    </details>
                    <details>
                        <summary>{t("business_corporate")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/business-accounts">{t("digital_business_account")}</a>
                            <a href="https://ncx.cx/company-cards">{t("company_crypto_debit_cards")}</a>
                            <a href="https://ncx.cx/plans">{t("business_account_plans")}</a>
                            <a href="https://ncx.cx/accounting">{t("invoicing_bookkeeping")}</a>
                            <a href="https://ncx.cx/institutional">{t("institutional_services")}</a>
                            <a href="https://ncx.cx/ncx-otc">{t("otc")}</a>
                        </div>
                    </details>
                    <details>
                        <summary>{t("rewards_affiliate")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/rewards">{t("rewards")}</a>
                            <a href="https://ncx.cx/ncx-ambassador">{t("ambassador_program")}</a>
                            <a href="https://ncx.cx/market-makers">{t("market_makers")}</a>
                        </div>
                    </details>
                    <details>
                        <summary>{t("company")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/about-us">{t("about_us")}</a>
                            {/* <a href="https://ncx.cx/market-insights">{t("news_press")}</a> */}
                        </div>
                    </details>
                    <details>
                        <summary>{t("support")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/faq">{t("faq")}</a>
                            <a href="https://exchange.ncx.cx/support" target="_blank" rel="noreferrer">{t("create_support_ticket")}</a>
                        </div>
                    </details>
                    <details>
                        <summary>{t("social_media")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://twitter.com/NCX_CX" target="_blank" rel="noreferrer">{t("twitter")}</a>
                            <a href="https://t.me/NCX_Official" target="_blank" rel="noreferrer">{t("telegram")}</a>
                            <a href="https://www.instagram.com/ncx.cx/" target="_blank" rel="noreferrer">{t("instagram")}</a>
                        </div>
                    </details>
                    <details>
                        <summary>{t("legal")}
                        <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.311311 0.418754C0.622234 0.0619783 1.12633 0.0619783 1.43725 0.418754L8.03968 7.99547L14.6421 0.418754C14.953 0.0619783 15.4571 0.0619783 15.768 0.418754C16.0789 0.77553 16.0789 1.35405 15.768 1.71082L8.60264 9.93358C8.29174 10.2904 7.78762 10.2904 7.47672 9.93358L0.311311 1.71082C0.000396326 1.35405 0.000396326 0.77553 0.311311 0.418754Z" fill="#FAFAFA"/>
                        </svg>
                        </summary>
                        <div className='mn-rr'>
                            <a href="https://ncx.cx/user-agreement">{t("user_agreement")}</a>
                            <a href="https://ncx.cx/kyc-aml-policy">{t("aml_kyc_policy")}</a>
                            <a href="https://ncx.cx/privacy-policy">{t("privacy_policy")}</a>
                            <a href="https://ncx.cx/api-agreement">{t("api_documentation")}</a>
                            <a href="https://ncx.cx/cookie-policy">{t("cookie_policy")}</a>
                        </div>
                    </details>
                    <div className="erbr">
                        <a href="https://exchange.ncx.cx/ieolist">{t("claim_airdrop")}</a>
                    </div>
                </div>
                {/* <div className="mob-foot-ul">
                    <ul>
                        <h1>{t("products")}</h1>
                        <li><a href="https://ncx.cx/buy-crypto">{t("buy_crypto")}</a></li>
                        <li><a href="https://exchange.ncx.cx/trade">{t("spot_trading")}</a></li>
                        <li><a href="https://ncx.cx/derivatives">{t("crypto_derivatives")}</a></li>
                        <li><a href="https://exchange.ncx.cx/markets">{t("markets")}</a></li>
                        <li><a href="https://bsc.ncx.cx/swap" target="_blank" rel="noreferrer">{t("cross_chain_dex")}</a></li>
                        <li><a href="https://ncx.cx/ncx-card">{t("ncx_card")}</a></li>
                        <li><a href="https://ncx.cx/wallet">{t("ncx_defi_wallet")}</a></li>
                        <li><a href="https://ncx.cx/ncx-token">{t("ncx_token")}</a></li>
                        <li><a href="https://ncx.cx/derivatives">{t("stocks_trading")}</a></li>
                        <li><a href="https://ncx.cx/derivatives">{t("forex_trading")}</a></li>
                        <li><a href="https://ncx.cx/derivatives">{t("commodities_trading")}</a></li>
                    </ul>
                    <ul>
                        <h1>{t("services")}</h1>
                        <li><a href="https://ncx.cx/market-insights">{t("ncx_insights")}</a></li>
                        <li><a href="https://ncx.cx/rewards">{t("rewards_program")}</a></li>
                        <li><a href="https://ncx.cx/market-makers">{t("market_makers")}</a></li>
                        <li><a href="https://ncx.cx/institutional">{t("institutional_services")}</a></li>
                        <li><a href="https://ncx.cx/ncx-otc">{t("otc")}</a></li>
                        <li><a href="https://ncx.cx/ncx-ambassador">{t("ncx_ambassador")}</a></li>
                        <li><a href="https://ncx.cx/faq">{t("faq")}</a></li>
                        <li><a href="https://exchange.ncx.cx/support" target="_blank" rel="noreferrer">{t("support")}</a></li>
                        <li><a href="https://ncx.cx/about-us">{t("about_us")}</a></li>
                        <li><a href="https://ncx.cx/market-insights">{t("media_press")}</a></li>
                    </ul>
                </div>
                <div className="mob-foot-ul">
                    <ul>
                        <h1>{t("legal")}</h1>
                        <li><a href="https://ncx.cx/user-agreement">{t("user_agreement")}</a></li>
                        <li><a href="https://ncx.cx/kyc-aml-policy">{t("aml_kyc_policy")}</a></li>
                        <li><a href="https://ncx.cx/privacy-policy">{t("privacy_policy")}</a></li>
                        <li><a href="https://ncx.cx/api-agreement">{t("api_documentation")}</a></li>
                        <li><a href="https://ncx.cx/cookie-policy">{t("cookie_policy")}</a></li>
                    </ul>
                    <ul>
                        <h1>{t("apps")}</h1>
                        <li><a href="#" target="_blank" rel="noreferrer">{t("ncx_app_on_app_store")}</a></li>
                        <li><a href="https://play.google.com/store/apps/details?id=com.application.ncx" target="_blank" rel="noreferrer">{t("ncx_app_on_google_play_store")}</a></li>
                        <li><a href="#">{t("ncx_ctrader_on_app_store")}</a></li>
                        <li><a href="#">{t("ncx_ctrader_on_google_play_store")}</a></li>
                    </ul>
                </div> */}
                <div className="mjh--s">
                    <div class="social-media">
                        <p>{t("follow_us")}</p>
                        <div className="social-icons">
                            <div class="icons"><a href="https://t.me/NCX_Official" target="_blank" rel="noreferrer"><img src={Telegram} alt="NCX" title="Telegram"/></a></div>
                            <div class="icons"><a href="https://twitter.com/NCX_CX" target="_blank" rel="noreferrer"><img src={Twitter} alt="NCX" title="Twitter" /></a></div>
                            <div class="icons"><a href="https://www.instagram.com/ncx.cx/" target="_blank" rel="noreferrer"><img src={Instagram} alt="NCX" title="Instagram" /></a></div>
                        </div>
                    </div>
                    <div className="appsttore">
                        <p>{t("mobile_app")}</p>
                        <a href="https://play.google.com/store/apps/details?id=com.application.ncx" target="_blank" rel="noreferrer"><img src={MBLNCXGoogle} alt="ncx-app-on-googleplay-store" /></a>
                        <img src={MBLNCXAppStore} alt="ncx-app-on-appstore" />
                    </div>
                </div>
                {/* <div className="fot-newsleter">
                    <p>{t("sign_up_for_updates")}</p>
                    <NCXNewsletter />
                </div> */}
                {/* <div className="app-barcode-row">
                    <div className="appsttore">
                        <p>{t("mobile_app")}</p>
                        <a href="https://play.google.com/store/apps/details?id=com.application.ncx" target="_blank" rel="noreferrer"><img src={MBLNCXGoogle} alt="ncx-app-on-googleplay-store" /></a>
                        <img src={MBLNCXAppStore} alt="ncx-app-on-appstore" />
                    </div>
                    <div className="bardcodd">
                        < img src="https://res.cloudinary.com/dqbcnwbvy/image/upload/v1693062241/qr-cdeo-_yvvhfn.svg" alt="NCX Barcode to Download App" />
                        <p>{t("scan_to_download_ncx_app")}</p>
                    </div>
                </div> */}
                <div class="copyright">
                    <p>{t("footer_copyright_1")} <a href="https://ncx.cx/user-agreement">{t("user_agreement")}</a>, <a href="https://ncx.cx/kyc-aml-policy">{t("aml_kyc_policy")}</a> {t("and")} <a href="https://ncx.cx/privacy-policy">{t("privacy_policy")}</a></p>
                    {/* <p>{t("footer_copyright_2")}</p> */}
                    <p>{t("footer_copyright_3")}</p>
                </div>
            </div>
        </div>
    )
}

export default MyFooter;